import { render, staticRenderFns } from "./CustomerListItem.vue?vue&type=template&id=6c263a72&"
import script from "./CustomerListItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports